import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import TeamEntry from "./views/Team/Entry.vue";
import ProjekteEntry from "./views/Projekte/Entry.vue";

import Meta from 'vue-meta';

Vue.use(Router);
Vue.use(Meta);

export default new Router({
  mode: 'hash',
  scrollBehavior(to) {
    if (to.hash) {
      return {
        el: to.hash,
        behavior: 'smooth',
      }
    }
  },
  routes: [
    {
      path: "/",
      name: "home",
      component: Home,
    },
    {
      path: "/team/:slug", // THE DYNAMIC URL
      name: "team",
      component: TeamEntry
    },
    {
      path: "/projekte/:slug", // THE DYNAMIC URL
      name: "projekte",
      component: ProjekteEntry
    },
  ],
});
